import React, { useContext } from 'react';
import { PaymentContext } from '../PaymentContext/context';

export default () => {
  const paymentCtx = useContext(PaymentContext);
  const Element = paymentCtx?.componentFactory;

  return Element ? <Element /> : null;
};
